import { memo, useEffect, useState } from "react";

import { CartSummaryComponent, ModalComponent } from "@zenith/components";
import {
  ItemsDetailsFormComponent,
  PaymentMethodComponent,
} from "@zenith/features/Payments/components";
import { UPGRADE_ACCOUNT } from "@zenith/routes/paths";
import {
  CONTINUE_BUTTON,
  POST_NO_DEBIT,
  POST_NO_DEBIT_MESSAGE,
  UPGRADE_ACCOUNT_BUTTON,
} from "@zenith/data/constants";
import { AppNavigation } from "@zenith/hooks";
import {
  ApiResponseDTOExceededLimitsDTO,
  LimitsApiService,
} from "@zenith/services/user";
import { PaymentMethodsEnum } from "@zenith/features/Payments/types";

const PaymentsPage = memo(function PaymentsPage() {
  const { navigateTo } = AppNavigation();
  const [isCartOpen, setIsCartOpen] = useState<boolean>(false);
  const [showClearCartPopup, setShowClearCartPopup] = useState<boolean>(false);
  const [showPostNoDebitModal, setShowPostNoDebitModal] =
    useState<boolean>(false);
  const [postNoDebitMessage, setPostNoDebitMessage] = useState<string>("");
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState<PaymentMethodsEnum | null>(null);

  useEffect(() => {
    LimitsApiService.getExceededLimits().then(
      (response: ApiResponseDTOExceededLimitsDTO) => {
        const hasLimits = Boolean(
          response.data?.creditLimitExceeded ||
            response.data?.balanceLimitExceeded
        );

        if (
          "data" in response &&
          response.data &&
          hasLimits &&
          response.data.needsUpgradeToTier
        ) {
          setShowPostNoDebitModal(hasLimits);
          setPostNoDebitMessage(
            POST_NO_DEBIT_MESSAGE.mapUpgradeTier(
              response.data.needsUpgradeToTier
            )
          );
        }
      }
    );
  }, []);

  const openModal = () => {
    setIsCartOpen(true);
  };

  const closeModal = () => {
    setIsCartOpen(false);
    setShowClearCartPopup(false);
  };

  function handleUpgradeAccountTier(): void {
    navigateTo(UPGRADE_ACCOUNT);
  }

  function closePostNoDebitModal(): void {
    setShowPostNoDebitModal(false);
  }
  return (
    <div className="mb-2 flex max-w-[96%] flex-col justify-around">
      <CartSummaryComponent
        isCartOpen={isCartOpen}
        openModal={openModal}
        closeModal={closeModal}
        showClearCartPopup={showClearCartPopup}
        setShowClearCartPopup={setShowClearCartPopup}
      />
      <div className="mt-14 flex w-3/5 flex-col items-center self-center rounded-[20px] border border-neutral-200">
        <PaymentMethodComponent
          selectedPaymentMethod={selectedPaymentMethod}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
        />
        <ItemsDetailsFormComponent
          openModal={openModal}
          closeModal={closeModal}
        />
      </div>
      <ModalComponent
        icon={"warning"}
        title={POST_NO_DEBIT}
        body={postNoDebitMessage}
        showModal={showPostNoDebitModal}
        onClickClose={closePostNoDebitModal}
        doubleOptions={true}
        leftButtonText={CONTINUE_BUTTON}
        rightButtonText={UPGRADE_ACCOUNT_BUTTON}
        onLeftButtonClick={closePostNoDebitModal}
        onRightButtonClick={handleUpgradeAccountTier}
      />
    </div>
  );
});

export default PaymentsPage;
